import React from 'react';
import PropTypes from 'prop-types';
import paginationFactory from 'react-bootstrap-table2-paginator';
import DefaultTableResize from '../DefaultTableResize';

const RemoteTable = ({ data, sort, columns, onTableChange, pagination, bsProps, margins }) => {
  const isPagination = pagination ? true : false;
  const margin = margins ? '' : 'content-marginless'

  const sizePerPageList = [
    {
      text: '10', value: 10
    }, {
      text: '25', value: 25
    }, {
      text: '50', value: 50
    }, {
      text: 'All', value: isPagination && pagination.totalSize ? pagination.totalSize : 100
    }
  ];

  return (
    <>
      <DefaultTableResize
        keyField="id"
        data={data}
        columns={columns}
        onTableChange={onTableChange}
        pagination={isPagination ? paginationFactory({sizePerPageList, ...pagination}) : null}
        bordered={ false }
        rowClasses='rbt-row-hovered'
        noDataIndication={ () => 'No content to show.' }
        className='h-full overflow-y-auto'
        {...bsProps}
      />
    </>
  )
}

RemoteTable.defaultProps = {
  data: []
}

RemoteTable.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  onTableChange: PropTypes.func,
  pagination: PropTypes.object
}

export default RemoteTable;